import BlogsDetailsComponent from "component/Landing/Blogs/BlogsDetails";

const BlogsDetails = () => {
  return <BlogsDetailsComponent />;
};

export default BlogsDetails;
